import { collection, query, getDocs } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function fetchAllExamResults(uid) {
  const resultsRef = collection(db, 'artifacts', appId, 'users', uid, 'exam_results');
  const snap = await getDocs(query(resultsRef));
  const hits = 0;
  const questions = 0;
  const rows = [];
  snap.forEach((doc) => {
    const data = doc.data();
    rows.push(data);
  });
  return rows;
}
